module.exports = __webpack_public_path__ + "static/media/play-icon.5ab754ee.png";